const { HMSNewsletterSignup } = require('./newsletterSignup');

/**
 * @class NewsletterSignupPopupAutoOpen
 */
window.HMSNewsletterSignupPopupAutoOpen = class NewsletterSignupPopupAutoOpen {
	constructor() {
		this.defaultInterval = 10;
		if (this.isOnPage() && !HMSNewsletterSignup.isCookieAccepted()) {
			this.openPopupAfterInterval();
		}
	}

	isOnPage() {
		return $('#newsletter-signup-popup').length !== 0;
	}

	/**
	 * Opens Newsletter Signup Popup after interval in seconds. Default interval is 5sec.
	 * @param {Number} interval - Interval in seconds
	 */
	openPopupAfterInterval() {
		const interval = window.HMSNewsletterSignupPopupInterval || this.defaultInterval;

		setTimeout(() => {
			$.magnificPopup.open({
				items: {
					src: '#newsletter-signup-popup'
				},
				type: 'inline'
			});
		}, interval * 1000);
	}
}
